import { render, staticRenderFns } from "./InfoAssignmentButton.vue?vue&type=template&id=050317c8&scoped=true"
import script from "./InfoAssignmentButton.vue?vue&type=script&lang=js"
export * from "./InfoAssignmentButton.vue?vue&type=script&lang=js"
import style0 from "./InfoAssignmentButton.vue?vue&type=style&index=0&id=050317c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050317c8",
  null
  
)

export default component.exports